<template>
  <div id="all-assessments" class="sonar-assessments">
    <div class="sonar-section__header">
      <div class="sonar-section__title-wrapper">
        <h5 class="sonar-section__title">All assessments</h5>
        <h6 class="sonar-section__subtitle">
          Unlock new levels by demonstrating your proficiency.
        </h6>
      </div>
      <SonarTabs v-if="userHasStats" />
    </div>

    <div v-if="isEnabled" class="sonar-assessments__groups-wrapper">
      <div
        v-for="(group, index) in assessments"
        :key="`sag-${index}`"
        class="sonar-assessments__cards-wrapper"
      >
        <div class="sonar-assessments__group-header">
          <img
            v-if="groupIcon(group)"
            :src="groupIcon(group)"
            class="sonar-assessments__group-icon"
            alt="Group icon"
          />
          <h4 class="sonar-assessments__group-name">
            {{ groupName(group) }}
          </h4>
        </div>

        <SonarAssessmentCard
          v-for="assessment in group.assessments"
          :key="assessment.id"
          :assessment="assessment"
        />
      </div>
    </div>
    <SonarMobileAlert v-if="showMobileAlertModal" />
  </div>
</template>

<script>
import SonarAssessmentCard from '@/sonar/components/SonarAssessmentCard.vue'
import SonarTabs from '@/sonar/components/SonarTabs.vue'
import SonarMobileAlert from '@/sonar/components/SonarMobileAlert.vue'
import { groupSetup } from '@/sonar/helpers/utils'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SonarAssessments',
  components: {
    SonarAssessmentCard,
    SonarTabs,
    SonarMobileAlert,
  },
  props: {
    assessments: {
      type: Array,
      required: true,
    },
    userHasStats: {
      type: Boolean,
      required: false,
    },
    isEnabled: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      showMobileAlertModal: 'sonar/showStartAssessmentModal',
    }),
  },
  methods: {
    ...mapActions({
      updateSonarStatus: 'sonar/updateSonarStatus',
    }),
    groupName(group) {
      const plural = group.assessments?.length > 1 ? 's' : ''
      return `${group.name} assessment${plural}`
    },
    groupIcon(group) {
      return groupSetup(group.slug)?.icon
    },
  },
}
</script>

<style lang="scss" scoped>
.sonar-assessments {
  margin-bottom: 80px;
  &__groups-wrapper {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
  &__group-header {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 2px;
  }
  &__group-name {
    margin: 0;
    color: var(--white);
    font-size: rem(16);
    line-height: rem(23);
  }
  &__group-icon {
    max-height: 26px;
    max-width: 26px;
  }
  &__cards-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
}
</style>
